import React from 'react'
import { Col, Row, Container } from '@microfrontends/react-components'
import {
	BannerContainer,
	ObjectWrapper,
	Object1,
	Object2,
	Wrapper,
	Heading
} from './Banner.css'
import CareerSearch from './components/CareerSearch'
import { ICareerPathByIndustry } from './types'

interface IProps {
	careerPathByIndustryData?: ICareerPathByIndustry[]
}

const IMAGE_SERVICE = process.env.IMAGE_BASE_URL + '/images/career-path'

const Banner: React.FC<IProps> = ({ careerPathByIndustryData = [] }) => {
	const flattenIndustries = (
		careerPathByIndustryData: ICareerPathByIndustry[]
	): ICareerPathByIndustry[] => {
		let flattenedIndustries: ICareerPathByIndustry[] = []
		if (careerPathByIndustryData) {
			careerPathByIndustryData.forEach((industry) => {
				if (industry.items !== null) {
					flattenedIndustries = [
						...flattenedIndustries,
						...flattenIndustries(industry.items)
					]
				} else {
					flattenedIndustries.push(industry)
				}
			})
		}
		return flattenedIndustries
	}

	return (
		<BannerContainer>
			<Wrapper>
				<Container>
					<Row gutter={[26, 0]}>
						<Col>
							<Heading>
								{'Tra cứu\nlộ trình sự nghiệp'}
								<p>
									Review to&nbsp;
									<span className='highlight'>Renew</span>
								</p>
							</Heading>
						</Col>
						<Col xs={24} md={12} lg={9}>
							<CareerSearch
								industries={flattenIndustries(
									careerPathByIndustryData
								)}
							/>
						</Col>
					</Row>
				</Container>
			</Wrapper>
			<ObjectWrapper>
				<picture>
					<source
						media={`(max-width: 1024px)`}
						srcSet={IMAGE_SERVICE + '/object-road-mobile.png'}
					/>
					<Object1
						src={IMAGE_SERVICE + '/object-road.png'}
						alt='Object road'
					/>
				</picture>
				<Object2
					src={IMAGE_SERVICE + '/object-person.png'}
					alt='Object person'
				/>
			</ObjectWrapper>
		</BannerContainer>
	)
}

export default Banner
